import React from 'react';
import classes from './CustomerPrintable.module.css';
import { ICustomer } from '../../../store/slices/customers';
import logo from '../../../assets/images/new-logo.svg';

import moment from 'moment/moment';
import { getPrintableHtml } from '../../../utils/miscUtils';
import PrimaryButtonV2 from '../Buttons/PrimaryButtonV2';

import { fetchGenders, Gender, selectGenders } from '../../../store/slices/gender';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  customer: ICustomer;
  qrCode?: string;
};
const CustomerPrintable: React.FC<Props> = ({ customer, qrCode }) => {
  const { translations } = useTranslation();
  const genders: Gender[] = useAppSelector(selectGenders);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(fetchGenders);
  }, [dispatch]);

  const gender = React.useMemo(() => {
    return genders.find((gender) => gender.gender_id === customer.person_gender_id)?.gender ?? '';
  }, [customer, genders]);

  return (
    <>
      <PrimaryButtonV2
        text={translations('print')}
        containerStyle={{
          justifyContent: 'left',
        }}
        buttonStyle={{
          height: 40,
          minWidth: 124,
          padding: '0 22px',
          fontSize: 16,
          fontWeight: 400,
          borderRadius: 6,
          marginLeft: 0,
        }}
        invertedColors
        onClick={() => {
          const htmlContent = document.getElementById('divToPrint')?.innerHTML;
          const printable = (document.getElementById('ifmContentsToPrint') as HTMLIFrameElement)
            .contentWindow;
          if (printable) {
            printable.document.open();
            printable.document.write(
              getPrintableHtml(htmlContent ?? '', Array.from(document.styleSheets))
            );
            printable.document.close();
            printable.focus();
            printable.print();
          }
        }}
      />
      <div className={classes.hidden}>
        <div id={'divToPrint'} className={classes.container}>
          <div className={classes.card}>
            <img className={classes.logo} src={logo} alt={'logo'} />
            <div className={classes.cardContent}>
              <div className={classes.fieldsContainer}>
                <div className={classes.fields}>
                  <div className={classes.infoContainer}>
                    <div className={classes.label}>{translations('full.name')}</div>
                    <div className={classes.value}>
                      {`${customer.person_firstname} ${customer.person_lastname}`}
                    </div>
                  </div>
                </div>
                <div className={classes.fields}>
                  <div className={classes.infoContainer}>
                    <div className={classes.label}>ID</div>
                    <div className={classes.value}>{customer.person_id}</div>
                  </div>
                </div>
                <div className={classes.fields}>
                  <div className={classes.infoContainer}>
                    <div className={classes.label}>{translations('date.of.birth')}</div>
                    <div className={classes.value}>
                      {moment(customer.person_birthdate).format('DD.MMMM.YYYY')}
                    </div>
                  </div>
                </div>
                <div className={classes.fields}>
                  <div className={classes.infoContainer}>
                    <div className={classes.label}>{translations('gender')}</div>
                    <div className={classes.value}>{gender}</div>
                  </div>
                </div>
              </div>
              <div className={classes.qrCodeContainer}>
                <img alt={'qr code'} src={qrCode} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <iframe
        title={translations('printable').toString()}
        id="ifmContentsToPrint"
        style={{ height: 0, width: 0, position: 'absolute' }}
      />
    </>
  );
};

export { CustomerPrintable };
